import barIndicator from "./barIndicator";
import cellExpandRenderer from "./cellExpandRenderer";
import deltaArrowTrendIndicator from "./deltaArrowTrendIndicator";
import heatMap from "./heatMap";
import percentFractionBarIndicator from "./percentFractionBarIndicator";
import percentFractionIndicator from "./percentFractionIndicator";
import sparklineIndicator from "./sparklineIndicator";
import trendIndicator from "./trendIndicator";
import compareABcolorful from "./compareABcolorful";
import ellipsis from "./ellipsis";
import statusPill from "./statusPill";
import date from "./date";
import dateTime from "./dateTime";
import starRating from "./starRating";
import contextMenuTrigger from "./contextMenuTrigger";
import materialIcon from "./materialIcon";
import updatedBy from "./updatedBy";
import scorePill from "./scorePill";
import colorPill from "./colorPill";

export const GSRenderers: Array<Function> = {
  barIndicator,
  cellExpandRenderer,
  deltaArrowTrendIndicator,
  heatMap,
  percentFractionBarIndicator,
  percentFractionIndicator,
  sparklineIndicator,
  trendIndicator,
  compareABcolorful,
  ellipsis,
  statusPill,
  date,
  dateTime,
  starRating,
  contextMenuTrigger,
  materialIcon,
  updatedBy,
  scorePill,
  colorPill,
};
